/** Portal sessions on this device: one per (person, organizer). Plain tokens live only here and in the URL. */
const KEY = "hk_org_sessions";

export const getSessions = () => {
  try { const v = JSON.parse(window.localStorage.getItem(KEY) || "[]"); return Array.isArray(v) ? v.filter((s) => s?.token && s?.organizer?.id) : []; } catch { return []; }
};

export const saveSessions = (list) => {
  const seen = new Set();
  const out = [];
  for (const s of list) { if (!s?.token || seen.has(s.token)) continue; seen.add(s.token); out.push(s); }
  window.localStorage.setItem(KEY, JSON.stringify(out));
  return out;
};

/** Merge freshly minted sessions: a new session for the same organizer replaces the old one. */
export const addSessions = (fresh, person) => {
  const current = getSessions().filter((s) => !fresh.some((f) => f.organizer.id === s.organizer.id));
  return saveSessions([...fresh.map((f) => ({ ...f, person })), ...current]);
};

export const removeSession = (token) => saveSessions(getSessions().filter((s) => s.token !== token));
export const clearSessions = () => window.localStorage.removeItem(KEY);
export const findSession = (token) => getSessions().find((s) => s.token === token) || null;
